import BaseService from "./base.service";
import $router from "../router";
import { CONFIG } from "@/config";

class CoursesService extends BaseService {
  get entity() {
    return "courses";
  }

  getCourseById(courseId, include) {
    let url = `${this.entity}/${courseId}`;
    if (include !== null && include !== undefined) {
      url +=
        "?include=learning_guide_assistant," +
        include +
        "&checkContractAgreement=true";
    } else {
      url +=
        "?checkContractAgreement=true&include=learning_guide_assistant,chat_assistant";
    }
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getProgress(courseId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`${this.entity}/${courseId}?include=user_progress`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
  getSectionsByCourseId(courseId) {
    return new Promise((resolve, reject) => {
      const queryParams = { include: "items.learnable" };
      const url = `${this.entity}/${courseId}/sections`;

      return this.request({ auth: true })
        .get(url, { params: queryParams })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response.status === 403) {
            $router.push(error.response.data.url);
          }
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getSectionItem(itemId, saveInCache = false) {
    if (saveInCache) {
      console.log(
        "TRY save in cache",
        `/api/v1/${this.entity}/items/${itemId}?include=learnable.video&checkContractAgreement=true`,
      );
      caches
        .open(CONFIG.CACHEV)
        .then(async (cache) => {
          try {
            cache.addAll([
              `/api/v1/${this.entity}/items/${itemId}?include=learnable.video&checkContractAgreement=true`,
            ]);
          } catch (error) {
            console.log("err cache in", error);
          }
        })
        .catch((err) => {
          console.log("err cache", err);
          if (err.status === 404 || err.status === 403) {
            this.$router.push("/courses");
          }
        });
    }

    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(
          `${this.entity}/items/${itemId}?include=learnable.video&checkContractAgreement=true`,
        )
        .then((response) => {
          resolve(response.data);
          console.log({ a: response });
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          console.log(
            "error getSectionItem",
            `${this.entity}/items/${itemId}?include=learnable.video&checkContractAgreement=true`,
          );
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getVideoLink(videoId, saveInCache = false) {
    if (saveInCache) {
      caches
        .open(CONFIG.CACHEV)
        .then(async (cache) => {
          try {
            cache.addAll([`/api/v1/videos/${videoId}/links`]);
          } catch (error) {
            console.log("err cache in", error);
          }
        })
        .catch((err) => console.log("err cache", err));
    }
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`/videos/${videoId}/links`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getResolutionDownload(linksObject, isMobile) {
    // console.log("Input parameters:", linksObject, isMobile);

    if (linksObject === null) {
      // console.log("Output: null");
      return null;
    }

    let downloadUrl;

    if (!!isMobile) {
      downloadUrl =
        linksObject.data.media_mobile_url ||
        linksObject.data.media_sd_url ||
        linksObject.data.media_hd_url ||
        null;
    } else {
      downloadUrl =
        linksObject.data.media_hd_url || linksObject.data.media_sd_url || null;
    }

    // console.log("Output:", downloadUrl);
    return downloadUrl;
  }

  // /api/v1/courses/1/items/2/next
  getMovedSectionItem(courseId, currentItemId, direction) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`${this.entity}/${courseId}/items/${currentItemId}/${direction}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getMyCourses() {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`${this.entity}/`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  logSectionItem(sectionItemId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(
          `${this.entity}/items/${sectionItemId}/log`,
          this.getBrowserIdOptions(),
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          // Error
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data)
            // console.log(error.response.status)
            // console.log(error.response.headers)
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request)
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          // console.log(error.config)
        });
    });
  }

  getLastItem(courseId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`${this.entity}/${courseId}/items/lastview`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          // Error
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data)
            // console.log(error.response.status)
            // console.log(error.response.headers)
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request)
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          // console.log(error.config)
        });
    });
  }

  getDashboard(courseId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`${this.entity}/${courseId}/dashboard`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          // Error
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data)
            // console.log(error.response.status)
            // console.log(error.response.headers)
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request)
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          // console.log(error.config)
        });
    });
  }

  getCertificationCourses(parameters = {}) {
    const params = {
      ...parameters,
    };
    return new Promise((resolve, reject) => {
      return this.request()
        .get(`courses-with-certification`, { params })
        .then((response) => {
          const data = response.data.data;
          resolve(this.responseWrapper(response, data));
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getAudio(itemId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`/audios/${itemId}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
}

export default new CoursesService();
